'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var Expandable = require('../../01.atoms/Expandable/Expandable.js');
var TextExpandable = require('../TextExpandable/TextExpandable.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-accordion-single',
    cnExpanded = "".concat(CLASSNAME, "--expanded"),
    cnBody = "".concat(CLASSNAME, "__body"),
    cnWrapperTitle = "".concat(CLASSNAME, "__wrapper-title"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnNotes = "".concat(CLASSNAME, "__notes"),
    cnWrapperInner = "".concat(CLASSNAME, "__wrapper-inner"),
    cnButton = "".concat(CLASSNAME, "__button"),
    cnIcon = "".concat(CLASSNAME, "__icon");
/**
 * 
 */

var AccordionSingle = /*#__PURE__*/function (_TextExpandable) {
  _rollupPluginBabelHelpers.inherits(AccordionSingle, _TextExpandable);

  var _super = _rollupPluginBabelHelpers.createSuper(AccordionSingle);

  function AccordionSingle() {
    var _thisSuper, _this;

    _rollupPluginBabelHelpers.classCallCheck(this, AccordionSingle);

    for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
      props[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(props));
    _this.state = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, _rollupPluginBabelHelpers.get((_thisSuper = _rollupPluginBabelHelpers.assertThisInitialized(_this), _rollupPluginBabelHelpers.getPrototypeOf(AccordionSingle.prototype)), "state", _thisSuper)), {}, {
      expanded: _this.props.expanded
    });
    return _this;
  }

  _rollupPluginBabelHelpers.createClass(AccordionSingle, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var expanded = this.state.expanded;
      var children = this.props.children;
      return nextState.expanded !== expanded || nextProps.children !== children;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          title = _this$props.title,
          notes = _this$props.notes,
          iconExpanded = _this$props.iconExpanded,
          iconCollapsed = _this$props.iconCollapsed,
          expanded = this.state.expanded,
          classes = [CLASSNAME, className],
          icon = expanded ? iconExpanded : iconCollapsed;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(classes, _rollupPluginBabelHelpers.defineProperty({}, cnExpanded, expanded))
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapperTitle,
        onClick: this.toggleExpandState
      }, /*#__PURE__*/React__default.createElement("span", {
        className: cnTitle
      }, /*#__PURE__*/React__default.createElement("span", null, title), notes && /*#__PURE__*/React__default.createElement("span", {
        className: cnNotes
      }, "\xA0", notes)), /*#__PURE__*/React__default.createElement("button", {
        className: cnButton,
        role: "button",
        "aria-label": "Expand Text"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        className: cnIcon,
        id: icon,
        size: "sm"
      }))), /*#__PURE__*/React__default.createElement(Expandable, {
        className: cnBody,
        classNameContent: cnWrapperInner,
        expanded: expanded,
        onMount: this.onExpandableMount
      }, children));
    }
  }]);

  return AccordionSingle;
}(TextExpandable);

_rollupPluginBabelHelpers.defineProperty(AccordionSingle, "MIN_HEIGHT", 0);
AccordionSingle.propTypes = {
  /** Child nodes */
  children: PropTypes.node.isRequired,

  /** Additional class name */
  className: PropTypes.string,

  /** Custom icon for when Accordion is collapsed */
  iconCollapsed: PropTypes.string,

  /** Custom icon for when Accordion is expanded */
  iconExpanded: PropTypes.string,

  /** Notes that are displayed smaller next to title */
  notes: PropTypes.string,

  /** Title of Accordion */
  title: PropTypes.string.isRequired
};
AccordionSingle.defaultProps = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, TextExpandable.defaultProps), {}, {
  iconCollapsed: 'caret-down',
  iconExpanded: 'times-small'
});

module.exports = AccordionSingle;
